import { createApp } from 'vue'
import App from './App.vue'
import UiMotionList from './components/UiMotionList.vue'
import router from './router'
import store from './store'
import { setupPwa } from './assets/js/pwa'

// Hightcharts
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
import loadExporting from 'highcharts/modules/exporting';
import VueHighcharts from 'vue-highcharts';
loadExporting(Highcharts);
Highcharts3D(Highcharts);

// Code editor
import VueCodemirror from 'vue-codemirror'
import { basicSetup } from 'codemirror'
import { oneDark } from '@codemirror/theme-one-dark'

createApp(App)
    .component('UiMotionList', UiMotionList)
    .use(store)
    .use(router)
    .use(VueHighcharts, { Highcharts })
    .use(VueCodemirror, {
        // optional default global options
        autofocus: true,
        disabled: false,
        indentWithTab: true,
        tabSize: 4,
        placeholder: 'Code goes here...',
        extensions: [basicSetup, oneDark]
        // ...
      })
    .mount('#app')

setupPwa();
